export default {
  header: '资料库',
  general: {
    fromDate: '日期由',
    endDate: '日期至',
    agentName: '顾问名称',
    customerName: '客户名称',
    gender: '性别',
    dob: '出生日期',
    agent: '顾问',
    agentCode: '顾问编号',
    customer: '客户',
    policyType: '保单类别',
    lifePolicy: '人寿保单',
    giPolicy: '一般保单',
    export: '汇出',
    status: '状况',
  },
  report: {
    header: '报告',
    customer: {
      customerCode: '客户编号',
      header: "客户",
      generalPolicyCount: '一般保险单数量',
      giPremium: '一般保险保费',
      lifePolicyCount: '人寿保险单数',
      lifePremium: '人寿保费',
    },
    performance: {
      header: '表现',
      agentCode: '顾问编号',
      teamCode: '团队编号',
      premium: '保额',
      commission: '佣金',
      cases: '单量',
      afyp: '年度化首年保费',
      fyc: '首年佣金',
      ifyp: '初始缴付首年保费'
    },
    sale: {
      premium: '保费',
      totalPremiums: '总保费',
      header: '销售',
      policyNumber: '保单号码',
      productName: '产品名称',
      policyOwner: '保单持有人',
      policyType: '保单类别',
      premiumType: '保费类别',
      provider: '保险公司',
      fyp: '首年保费',
      fyc: '首年佣金',
    },
    commission: {
      header: '佣金',
      policyType: '保单类别',
      productCode: '产品编号',
      commissionAcutalReceived: '实收佣金'
    }
  },


}


// WEBPACK FOOTER //
// ./src/Dw/langs/zh_cn/index.js